module.exports = __webpack_public_path__ + "img/rep_beer.40e6b1c9.jpg";